import { IAtitudeLegenda } from "@deltasge/marauders-map";
import {
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Accordion } from "components/Accordion";
import React, { FC } from "react";

export const AccordionAtitudeComponent: FC<{ atitudes: IAtitudeLegenda[] }> = ({
  atitudes,
}) => {
  return (
    <Accordion variant="outlined" defaultExpanded>
      <AccordionSummary>
        <Typography variant="subtitle2">Atitudes</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Menção</TableCell>
              <TableCell>Descrição</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {atitudes.map((atitude, index) => (
              <TableRow hover key={`atitude-${index}-${atitude.id}`}>
                <TableCell>{atitude.legenda}</TableCell>
                <TableCell>{atitude.descricao}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  );
};
